// オーダーカーテン見積もり
import dayjs from 'dayjs'
import { getProductFromHandle } from '~/js/helpers/getProducts'
import { ID_DATA } from '~/js/constants/data-element-ids'
import { baseUrlFrontApi } from '~/js/templates/index/helpers'
import axios from 'axios'
const ID_QUOTE_HISTORY = 'js-quote-history'

document.addEventListener('DOMContentLoaded', async () => {
  const elementQuoteHistory = document.getElementById(ID_QUOTE_HISTORY)
  const elementData = document.getElementById(ID_DATA)
  if (!elementQuoteHistory || !elementData) return

  try {
    const customerId = elementData.dataset.customerId
    const h = elementData.dataset.hashedCustomerId
    if (!customerId || !h) return
    const { data: quoteData } = await axios.get(
      `${baseUrlFrontApi}/customers/order_curtain_quotation/list`,
      {
        params: {
          customerId,
          h,
        },
      }
    )
    window.shopifyCustomerQuoteData = quoteData
    renderQuotes(quoteData, $(`#${ID_QUOTE_HISTORY}`))
  } catch (error) {
    console.error(error)
  }
})

/** Todo 以下リファクタ */
const toLocalPrice = (val) => {
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency: 'JPY',
  }).format(parseInt(`${val}`.slice(0, -2)))
}

const renderAccessories = (acce) => {
  let html = ''
  if (acce.length) {
    acce.forEach((item) => {
      if (html.length > 0) {
        html = html.concat(
          `, <span class="options" data-handle="${item.handle}" data-variant="${item.variantId}">${item.fabricName}</span>`
        )
      } else {
        html = html.concat(
          `<span class="options" data-handle="${item.handle}" data-variant="${item.variantId}">${item.fabricName}</span>`
        )
      }
    })
  }
  return html
}

const renderQuotes = (items, container) => {
  let html = `
    <div class="quote_list_heading">
      <span>お見積りの保存が完了しました</span>
      <select id="quote-sort">
        <option value="asc" selected>Date &#8593;</option>
        <option value="dec">Date &#8595;</option>
      </select>
    </div>`

  if (!items?.length) {
    container.html(
      `<div class="no-orders-message">お見積りリスト 履歴はまだありません。</div>`
    )
    return
  }

  Promise.all(
    items.map(async (item) => {
      try {
        // MAIN PRODUCT
        const prd_info = await getProductFromHandle(item.quotation.handle)
        const prd_variant = prd_info.variants.find(
          (x) => x.id == item.quotation.variantId
        )

        // OPTIONAL PRODUCT
        let optional_info = []
        let option_total = 0
        let option_breakdown = ''

        if (item.quotation.accessories.length) {
          let accessories = item.quotation.accessories
          for (let x = 0; x < accessories.length; x++) {
            const accessory = accessories[x]
            optional_info.push({
              name: accessory.fabricName,
              variant: accessory.variantId,
              data: await getProductFromHandle(accessory.handle),
            })
          }

          optional_info.forEach((v) => {
            const option_price =
              v.data.variants.find((x) => x.id == v.variant).price *
              item.quotation.curtains
            if (option_breakdown.length > 0) {
              option_breakdown = option_breakdown.concat(
                `,${v.variant}:${option_price}`
              )
            } else {
              option_breakdown = option_breakdown.concat(
                `${v.variant}:${option_price}`
              )
            }
            option_total =
              option_total +
              v.data.variants.find((x) => x.id == v.variant).price
          })
        }

        // PRICING
        let main_breakdown = prd_variant.price * item.quotation.curtains
        let grand_total =
          (prd_variant.price + option_total) * item.quotation.curtains
        const new_price = toLocalPrice(grand_total)

        // HOOK TYPE
        let hook_type
        if (item.quotation.hookType == 'A') {
          hook_type = '天付けAフック'
        } else if (item.quotation.hookType == 'B') {
          hook_type = '正面付けBフック'
        }
        html += `
          <div id="${item.id}" class="quotes__history-row" data-created="${
          item.updatedAt ? item.updatedAt : dayjs()
        }">
            <div class='quotes-history-information'>
              <div class="quote_header">
                <input type="hidden" id="quote_${item.id}" />
                <span class="quote_checkbox" data-item-id="${item.id}"></span>
                <label>このお見積りを選択する</label>
                <span class="quote_date">${
                  item.updatedAt
                    ? dayjs(item.updatedAt).format('YY-MM-DD HH:mm')
                    : dayjs().format('YY-MM-DD HH:mm')
                }</span>
              </div>
              <div class="product_info">
                <div class="quote_type">オーダーカーテン</div>
                <div class="prd_img"> <img src="${
                  prd_info.featured_image
                }"> </div>
                <div class="prd_details">
                  <p>${prd_info.title}</p>
                  <p>カラー : ${item.quotation.color}</p>
                  <p data-variant="${item.quotation.variantId}" data-handle="${
          item.quotation.handle
        }">品番 : ${prd_variant.sku}</p>
                  <p>合計金額 : <b id="grand" data-grand="${grand_total}" data-option-breakdown="${option_breakdown}"
                      data-main-breakdown="${main_breakdown}">${new_price}</b><small>税込</small></p>
                </div>
              </div>
              <div class="quote_info">
                <button class="quote_fix">修正</button>
                <p><span>窓のタイプ : </span>${item.quotation.windowType}</p>
                <p><span>スタイル : </span>${item.quotation.curtainStyle}</p>
                <p><span>開き方 : </span>${item.quotation.openingType}</p>
                <p><span>採寸幅 : </span>${
                  item.quotation.widthCustomerMeasured
                }</p>
                <p><span>採寸丈 : </span>${
                  item.quotation.heightCustomerMeasured
                }</p>
                <p><span>仕上がり幅 : </span>${item.quotation.width}</p>
                <p><span>仕上がり丈 : </span>${item.quotation.height}</p>
                <p><span>フックタイプ : </span>${hook_type}</p>
                <p><span>調整丈 : 測ったサイズから</span>${
                  item.quotation.length
                }</p>
                <p><span>有料オプション : </span>${renderAccessories(
                  item.quotation.accessories
                )}</p>
                <p><span>窓数 : </span>${item.quotation.windows}</p>
                <p><span>枚数 : </span>${item.quotation.curtains}</p>
              </div>
              <div class="quote_action">
                <button class="btn-delete">削除</button>
              </div>
            </div>
          </div>`
      } catch (error) {
        console.error(error)
      }
    })
  ).then(() => {
    container.html(html)
    $(document).on('change', '#quote-sort', function (_) {
      const sort = $(this).val()
      const ul = $(`#${ID_QUOTE_HISTORY}`)
      let items = $(`#${ID_QUOTE_HISTORY} > .quotes__history-row`).get()
      items.sort(function (a, b) {
        const keyA = dayjs($(a).attr('data-created'))
        const keyB = dayjs($(b).attr('data-created'))

        if (sort.includes('asc')) {
          if (keyA.isAfter(keyB)) return -1
          if (keyA.isBefore(keyB)) return 1
        } else {
          if (keyA.isAfter(keyB)) return 1
          if (keyA.isBefore(keyB)) return -1
        }
        return 0
      })
      $.each(items, function (i, li) {
        ul.append(li)
      })
    })
    $('#quote-sort').trigger('change')
    $('#total-wrapper').removeClass('hidden')
  })
}
